module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1b_Image5b.f268a2dc.jpg";